import React from 'react'

import ContentLoader from 'react-content-loader'

export const ChannelsListLoader = () => (
  <ContentLoader
    speed={2}
    backgroundColor={'#fff'}
    foregroundColor={'#fff'}
    backgroundOpacity={0.05}
    foregroundOpacity={0.15}
    style={{
      marginLeft: '16px',
      width: '502',
      height: '600px',
    }}
    viewBox="0 0 502 600"
    preserveAspectRatio="none"
    beforeMask={
      <>
        <rect
          width="100%"
          height="112px"
          y="0"
          x="0"
          opacity="0.1"
          fill="#fff"
        />
        <rect
          width="100%"
          height="112px"
          y="120"
          x="0"
          opacity="0.1"
          fill="#fff"
        />
        <rect
          width="100%"
          height="112px"
          y="240"
          x="0"
          opacity="0.1"
          fill="#fff"
        />
        <rect
          width="100%"
          height="112px"
          y="360"
          x="0"
          opacity="0.1"
          fill="#fff"
        />
        <rect
          width="100%"
          height="112px"
          y="480"
          x="0"
          opacity="0.1"
          fill="#fff"
        />
      </>
    }
  >
    <rect x="0" y="0" width="180" height="112" />
    <rect x="200" y="18" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="46" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="82" rx="5" ry="5" width="140" height="14" />

    <rect x="0" y="120" width="180" height="112" />
    <rect x="200" y="138" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="166" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="202" rx="5" ry="5" width="140" height="14" />

    <rect x="0" y="240" width="180" height="112" />
    <rect x="200" y="258" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="286" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="322" rx="5" ry="5" width="140" height="14" />

    <rect x="0" y="360" width="180" height="112" />
    <rect x="200" y="378" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="406" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="442" rx="5" ry="5" width="140" height="14" />

    <rect x="0" y="480" width="180" height="112" />
    <rect x="200" y="498" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="526" rx="5" ry="5" width="240" height="18" />
    <rect x="200" y="562" rx="5" ry="5" width="140" height="14" />
  </ContentLoader>
)
